import * as m from "mithril";
import { NavBar } from '../../components/NavBar';
import AppContext from '../../context/AppContext';
//import TripSummaryCard from "./TripSummaryCard";
import { InputGroup, RadioGroup, Option } from "../../components/BootstrapForm";
import { MessageProvider } from '../../context/AppMessages';
import TripSearchResultSummaryView from "../../components/TripSearchResultSummaryView";
import ModalDialog from '../../components/ModalDialog';
import buildLanguageChangeActions from "../common/LanguageNavActions";
import { GenderType, InternationalStringDTO, SeatDTO, TravellerDTO, TripCustomizationDTO, TripResultDTO } from "../../apiclient/ApiDtos";
import { OrderedSeatsComponent } from "./SelectedSeatsComponent";
import { getIntlStringValue } from "../../helpers/StringHelpers";
import CustomSvgIcon from "../../components/CustomSvgIcon";
import { PickupDropOffDetailsComponent } from "../common/pickupdropoffInfo/PickupDropOffInfoDetails";
import { formatMoney } from "../../helpers/MoneyFormatter";

interface Attrs {
    appContext: AppContext,
    messageProvider: MessageProvider,
    tripCustomization: TripCustomizationDTO,
    prefilledTravellerName?: string | null,
    prefilledTravellerMsisdn?: string | null,
    isBacktracking: boolean,
    backTrackingTo?: 'WAYPOINT_SELECTION' | 'SEAT_SELECTION' | 'SEAT_AUTOASSIGNMENT_INFO',
    prefilledTravellerInfo?: TravellerDTO,
    onBacktrack: () => void,
    onBacktrackCancelled: () => void,
    onBacktrackConfirmed: () => void,
    onSubmit: (travellerInfo: TravellerDTO) => void,
    isSubmitting: boolean
}

function TravellerFormPage(): m.Component<Attrs> {
    let invalidFieldRequiringAttention: { name: string, pirority: number } | null = null;

    function updateInvalidFieldRequiringAttention(name: string, pirority: number) {
        if (invalidFieldRequiringAttention) {
            if (pirority < invalidFieldRequiringAttention.pirority) {
                invalidFieldRequiringAttention = { name: name, pirority: pirority };
            }
        } else {
            invalidFieldRequiringAttention = { name: name, pirority: pirority };
        }
        //if(invalidFieldRequiringAttention == null) {
        //    invalidFieldRequiringAttention = {name:name, pirority: pirority};
        //}
    }

    function getIntlString(messageProvider: MessageProvider, key: string): InternationalStringDTO {
        let intlStr = {
            en: messageProvider.get(key, {}, 'en'),
            my: messageProvider.get(key, {}, 'my')
        }
        return intlStr;
    }

    let travellerFormDTO: TravellerDTO = {
        name: "",
        email: "",
        phoneNumber: "",
        gender: "MIXED",
        specialRequest: ""
    };

    return {
        oninit(vnode) {
            travellerFormDTO.phoneNumber = vnode.attrs.prefilledTravellerMsisdn || "";

            if (vnode.attrs.prefilledTravellerInfo) {
                travellerFormDTO.name = vnode.attrs.prefilledTravellerInfo.name;
                travellerFormDTO.email = vnode.attrs.prefilledTravellerInfo.email;
                travellerFormDTO.phoneNumber = vnode.attrs.prefilledTravellerInfo.phoneNumber;
                travellerFormDTO.gender = vnode.attrs.prefilledTravellerInfo.gender;
                travellerFormDTO.specialRequest = vnode.attrs.prefilledTravellerInfo.specialRequest;
            }

            setTimeout(() => {
                document
                    .getElementById("form-traveller-name")
                    ?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 100);
        },

        view(vnode) {
            let messageProvider = vnode.attrs.messageProvider;
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);

            let currLang = vnode.attrs.messageProvider.getCurrentLang();
            let notices: InternationalStringDTO[] = vnode.attrs.tripCustomization.trip.notices || [];
            //console.log("Priority invalid field", invalidFieldRequiringAttention);

            //https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inert
            let formInert = vnode.attrs.isSubmitting ? { "inert": "inert" } : {}

            let unitGenderOption: Option[] = [
                { label: messageProvider.get("traveller_form.gender_option_male"), value: "MALE_ONLY" },
                { label: messageProvider.get("traveller_form.gender_option_female"), value: "FEMALE_ONLY" }
            ]

            let pluralGenderOption: Option[] = [
                { label: messageProvider.get("traveller_form.gender_option_male"), value: "MALE_ONLY" },
                { label: messageProvider.get("traveller_form.gender_option_female"), value: "FEMALE_ONLY" },
                { label: messageProvider.get("traveller_form.gender_option_mixed_group"), value: "MIXED" }
            ]

            return m("div.app-layout", [
                m(NavBar, {
                    title: messageProvider.get('nav_title.traveller_info'),
                    canBackPress: true,
                    actionItems: langChangeActionItems,
                    onBackPressed: () => {
                        vnode.attrs.onBacktrack();
                    }
                }),

                m("div.app-area-below-nav",

                ),

                m("div.app-area-main",
                    m("div.card shadow-sm",
                        m("div.card-body p-3", [
                            m(TripSearchResultSummaryView, {
                                messageProvider: vnode.attrs.messageProvider,
                                numberOfSeats: vnode.attrs.tripCustomization.seatOrder.numberOfSeats,
                                tripResult: vnode.attrs.tripCustomization.trip,
                                selectedSeats: vnode.attrs.tripCustomization.seatOrder.seatSelections,
                                showingDate: true,
                                hideTripPriceRange: vnode.attrs.tripCustomization.trip.isSeatSelectionAllowed
                            }),
                            (notices.length > 0) ?
                                m("div", { class: "alert alert-info mt-2 mb-0 p-2" },
                                    [
                                        m("small.font-weight-bold",
                                            vnode.attrs.appContext.getMessageProvider().get("trip.operator_notices", {
                                                name: getIntlStringValue(vnode.attrs.tripCustomization.trip.operator.name, currLang)
                                            })
                                        ),
                                        notices.map(notice => {
                                            return m("div", { class: "small" }, "- " + getIntlStringValue(notice, currLang))
                                        })
                                    ]
                                )
                                : null,
                        ]),

                        !vnode.attrs.tripCustomization.trip.isSeatSelectionAllowed ?
                            /* m("div.card-body border-top p-3",
                                m(OrderedSeatsComponent, {
                                    isSeatingAuto: !vnode.attrs.tripCustomization.trip.isSeatSelectionAllowed,
                                    allowCollapse: true,
                                    messageProvider: vnode.attrs.messageProvider,
                                    seatSelections: vnode.attrs.tripCustomization.seatOrder.seatSelections
                                })
                            )  */
                            m("div.card-body bg-light border-0 px-2",
                                m("div.important-info-alert",
                                    m("div.small font-weight-bold",
                                        vnode.attrs.messageProvider.get("small_car_details.seating_is_auto")
                                    )
                                ),

                                m("div.d-flex small mt-3 font-weight-bold",
                                    m("div.text-muted", vnode.attrs.messageProvider.get("no_of_seats"), " -"),
                                    m("div.ml-3 ", vnode.attrs.tripCustomization.seatOrder.seatSelections.length,
                                        " ",
                                        vnode.attrs.tripCustomization.seatOrder.seatSelections.length > 1 ?
                                            vnode.attrs.messageProvider.get("seats") :
                                            vnode.attrs.messageProvider.get("seat")

                                    )
                                ),

                                /* m("div.d-flex small mt-3 font-weight-bold",
                                    m("div.text-muted", vnode.attrs.messageProvider.get("total_seat_price"), " -"),
                                    m("div.ml-3 text-success",
                                        formatMoney(                                        {
                                            amount: vnode.attrs.tripCustomization.seatOrder.seatSelections.reduce(
                                                (acc, seat) => acc + seat.price.amount,
                                                0
                                            ),
                                            currency: "MMK"
                                        })

                                    )
                                ) */
                            )
                            :
                            m("div.card-body p-0",

                                m("div.px-3 pb-3",
                                    m(OrderedSeatsComponent, {
                                        isSeatingAuto: !vnode.attrs.tripCustomization.trip.isSeatSelectionAllowed,
                                        allowCollapse: true,
                                        messageProvider: vnode.attrs.messageProvider,
                                        seatSelections: vnode.attrs.tripCustomization.seatOrder.seatSelections
                                    })
                                )
                            )
                        ,
                        (vnode.attrs.tripCustomization.pickUpOrder && vnode.attrs.tripCustomization.pickUpOrder.lineItems.length > 0)
                            || (vnode.attrs.tripCustomization.dropOffOrder && vnode.attrs.tripCustomization.dropOffOrder.lineItems.length > 0) ?
                            m("div.card-body border-top p-3",
                                m(PickupDropOffDetailsComponent, {
                                    messageProvider: vnode.attrs.messageProvider,
                                    totalNumberOfSeats: vnode.attrs.tripCustomization.seatOrder.numberOfSeats,
                                    trip: vnode.attrs.tripCustomization.trip,
                                    pickUpOrder: vnode.attrs.tripCustomization.pickUpOrder,
                                    dropOffOrder: vnode.attrs.tripCustomization.dropOffOrder
                                })

                            ) : null
                    ),

                    m("div.p-3 pb-5 bg-white mt-2", {
                        style: "margin-bottom: 100px; !important"
                    },
                        m("form.traveller-form pt-2", {
                            id: "travellerForm",
                            onclick: (event) => {
                                invalidFieldRequiringAttention = null;
                            },
                            ...formInert
                        }, [
                            m(InputGroup, {
                                id: "form-traveller-name",
                                label: messageProvider.get("traveller_form.name"),
                                name: "name",
                                lang: messageProvider.getCurrentLang(),
                                required: true,
                                maxlength: 50,
                                initialValue: vnode.attrs.prefilledTravellerInfo?.name,
                                getCustomValidityMessage: (vs) => getIntlString(messageProvider, "validity.traveller_name"),
                                onValueChange: (newValue: string) => {
                                    travellerFormDTO.name = newValue;
                                },
                                onInvalid: vs => {
                                    updateInvalidFieldRequiringAttention("name", 1);
                                },
                                validityReportingAllowed: "name" == invalidFieldRequiringAttention?.name
                            }),

                            (vnode.attrs.tripCustomization != null) ?
                                m(RadioGroup, {
                                    label: messageProvider.get("traveller_form.gender"),
                                    name: "type",
                                    lang: messageProvider.getCurrentLang(),
                                    options: (vnode.attrs.tripCustomization.seatOrder.numberOfSeats > 1) ? pluralGenderOption : unitGenderOption,
                                    required: true,
                                    initialValue: vnode.attrs.prefilledTravellerInfo?.gender,
                                    getCustomValidityMessage: (vs) => getIntlString(messageProvider, "validity.required_selection"),
                                    onValueChange: (newValue: string) => {
                                        travellerFormDTO.gender = <GenderType>newValue;

                                    },
                                    onInvalid: vs => {
                                        updateInvalidFieldRequiringAttention("type", 2);
                                    },
                                    validityReportingAllowed: "type" == invalidFieldRequiringAttention?.name
                                }) : null,

                            /*    
                            m(InputGroup, {
                                    label: messageProvider.get("traveller_form.phone"),
                                    name: "phoneNumber",
                                    required: true,
                                    maxlength: 50,
                                    //customValidity: messageProvider.get("validity.traveller_name"),
                                    onValueChange: (newValue:string) => {
                                        travellerFormDTO.name = newValue;
                                    }
                            }), */

                            m(InputGroup, {
                                label: messageProvider.get("traveller_form.phone"),
                                lang: messageProvider.getCurrentLang(),
                                name: "phoneNumber",
                                type: 'tel',
                                required: true,
                                pattern: "^09[0-9]{7,9}$",
                                placeholder: "09 _ _ _ _ _ _ _",
                                maxlength: 16, // there could be extra stuffs when copy and paste
                                inputmode: 'number',
                                initialValue: vnode.attrs.prefilledTravellerInfo?.phoneNumber,
                                getCustomValidityMessage: (vs) => {
                                    //console.log(vs);
                                    if (vs && vs.valueMissing) {
                                        return getIntlString(messageProvider, "validity.required_phone_number");
                                    } else {
                                        return getIntlString(messageProvider, "validity.invalid_phone_number");
                                    }
                                },
                                instruction: messageProvider.get("traveller_form.phone_instruction"),
                                onValueChange: (newValue: string) => {
                                    travellerFormDTO.phoneNumber = newValue;
                                },
                                onInvalid: vs => {
                                    updateInvalidFieldRequiringAttention("phoneNumber", 3);
                                },
                                validityReportingAllowed: "phoneNumber" == invalidFieldRequiringAttention?.name
                            }),

                            m(InputGroup, {
                                label: messageProvider.get("traveller_form.email"),
                                lang: messageProvider.getCurrentLang(),
                                name: "email",
                                type: "email",
                                pattern: "^.*[\.]{1}[a-zA-Z]{2,6}$",
                                optional: true,
                                inputmode: 'email',
                                instruction: messageProvider.get("traveller_form.email_instruction"),
                                initialValue: vnode.attrs.prefilledTravellerInfo?.email,
                                getCustomValidityMessage: (vs) => getIntlString(messageProvider, "validity.email"),
                                onValueChange: (newValue: string) => {
                                    travellerFormDTO.email = newValue;
                                },
                                onInvalid: vs => {
                                    updateInvalidFieldRequiringAttention("email", 4);
                                },
                                validityReportingAllowed: "email" == invalidFieldRequiringAttention?.name
                            }),

                            m(InputGroup, {
                                label: messageProvider.get("traveller_form.special_request"),
                                lang: messageProvider.getCurrentLang(),
                                name: "specialRequest",
                                optional: true,
                                //instruction: "Please write a short description.",
                                initialValue: vnode.attrs.prefilledTravellerInfo?.specialRequest,
                                onValueChange: (newValue: string) => {
                                    travellerFormDTO.specialRequest = newValue;
                                },
                                onInvalid: vs => {

                                }
                            }),


                        ])
                    ),
                    m("div.fixed-bottom",
                        m("div", { class: "card card-elevated-1" },
                            m("div.card-body p-3", {},
                                m("button", {
                                    type: "submit",
                                    form: "travellerForm",
                                    class: "btn btn-primary btn-block",
                                    disabled: (vnode.attrs.isSubmitting) ? "disabled" : null,
                                    onclick: (event: Event) => {
                                        event.preventDefault();
                                        invalidFieldRequiringAttention = null;

                                        let form = <HTMLFormElement>document.getElementById("travellerForm");
                                        if (form != null) {
                                            let formIsValid = form.checkValidity();
                                            console.log("form is valid : ", formIsValid);
                                            if (formIsValid == true) {
                                                vnode.attrs.onSubmit(travellerFormDTO);
                                            }
                                        }
                                    }
                                },
                                    (vnode.attrs.isSubmitting) ?
                                        messageProvider.get("traveller_form.submitting") + "..." :
                                        messageProvider.get("traveller_form.submit")
                                )
                            )
                        )

                    )
                ),

                m(ModalDialog, {
                    //title: (vnode.attrs.backTrackingTo =='WAYPOINT_SELECTION') ? messageProvider.get("common.back") : messageProvider.get("warning"),
                    title: messageProvider.get("common.back"),
                    message: (vnode.attrs.backTrackingTo =='WAYPOINT_SELECTION') ? messageProvider.get("waypoint_selection_edit_confirm_message") : messageProvider.get("back_to_seat_selection_confirmation_description"),
                    shouldOpen: vnode.attrs.isBacktracking,
                    iconType: 'exclamation_circle',
                    iconThemeClass: " svg-medium svg-info",
                    onClosed: () => {
                        vnode.attrs.onBacktrackCancelled()
                    },

                    actionItems: [
                        {
                            //label: (vnode.attrs.backTrackingTo =='WAYPOINT_SELECTION') ? "Yes" : "OK",
                            label: "Yes",
                            onclick: () => {
                                vnode.attrs.onBacktrackConfirmed()
                            }
                        },
                        {
                            //label: (vnode.attrs.backTrackingTo =='WAYPOINT_SELECTION') ? "No" : "Cancel",
                            label: "No",
                            onclick: () => {
                                vnode.attrs.onBacktrackCancelled();
                            }
                        }

                    ]
                })
            ])
        }
    }
}

function isEmpty(value: string | null) {
    return value == null || value.trim() == "";
}

function isValidEmail(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

function isValidPhoneNumber(phoneNumber: String) {
    let phoneNumberElem = document.getElementById('phoneNumber');
    if (phoneNumberElem != null) {
        phoneNumberElem.addEventListener('input', function (e: any) {
            var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,9})/);
            if (!x[2]) {
                e.target.value = x[1];
            } else {
                if (x[1] != '09') {
                    e.target.value = '09' + x[1] + x[2];
                } else {
                    e.target.value = '09' + x[2];
                }
            }
        });
    }
}

export default TravellerFormPage;
